
import React, { createContext, useContext, useState, useEffect } from "react";

const CarRentalContext = createContext();

const LOCAL_STORAGE_KEY = "favoriteCars";

const getInitialFavorites = () => {
  try {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

const initialCars = [
  {
    id: 1,
    name: "Cadillac Escalade",
    image: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751740926/my25-escalade-mov-gallery-grid-exterior-front-grille-v2_nty5e7.jpg",
    short: "Luxury SUV with premium comfort and advanced features.",
    description:
      "The Cadillac Escalade offers luxurious interiors, climate-controlled seating, panoramic views, and a powerful V8 engine. Perfect for family trips or business travel with style.",
    highlights: [
      "CD Stereo", "Air Conditioning", "Tinted windows", "Luxury Interiors", "Advanced Entertainment"
    ],
    seats: "7 seats",
    color: "Black",
    price: 125, // USD per day
    tag: "luxury"
  },
  {
    id: 2,
    name: "Hyundai Palisade",
    image: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751740941/20220414061536_Hyundai_Palisade_facelift_front_pcwy2q.jpg",
    short: "Spacious premium SUV with family-friendly comfort.",
    description:
      "The Hyundai Palisade features leather interiors, DVD entertainment, iPod connectivity, ski box options, and excellent safety features, making it a great choice for long family journeys.",
    highlights: [
      "DVD Player", "iPod Connection", "Air Conditioning", "Ski Box", "Advanced Safety"
    ],
    seats: "7 seats",
    color: "Black",
    price: 140,
    tag: "family"
  },
  {
    id: 3,
    name: "Lexus ES 350",
    image: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751740955/lexus-es-facelift-china_ii2wgx.jpg",
    short: "Refined premium sedan with smooth drive and comfort.",
    description:
      "Experience the Lexus ES 350 with advanced air conditioning, top-tier sound, luxurious seating, and effortless driving pleasure for your personal or corporate needs.",
    highlights: [
      "DVD Player", "CD Stereo", "Air Conditioning", "Panoramic View Roof"
    ],
    seats: "5 seats",
    color: "White",
    price: 140,
    tag: "premium"
  },
  {
    id: 4,
    name: "Range Rover Sport",
    image: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751740973/IMG_7269-jpeg_uqwmqo.webp",
    short: "Off-road luxury and performance combined in a powerful SUV.",
    description:
      "Travel anywhere in comfort and style with Range Rover Sport's advanced AWD technology, luxury cabin, panoramic sunroof, and modern entertainment systems.",
    highlights: [
      "4x4 Drive", "Climate Control", "Premium Sound", "Panoramic Roof"
    ],
    seats: "5 seats",
    color: "Black",
    price: 160,
    tag: "luxury"
  },
  {
    id: 5,
    name: "Mercedes-Benz GLC",
    image: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751740989/front-left-side-47_h7vsoo.jpg",
    short: "Stylish midsize SUV with advanced technology and class-leading comfort.",
    description:
      "Mercedes GLC combines refined interiors with innovative safety features, perfect for city drives and highway touring with a premium feel throughout.",
    highlights: [
      "Apple CarPlay", "Premium Sound", "Leather Interior", "Advanced Safety"
    ],
    seats: "5 seats",
    color: "Silver",
    price: 150,
    tag: "premium"
  },
  {
    id: 6,
    name: "Ford Explorer",
    image: "https://res.cloudinary.com/dyuskzmn3/image/upload/v1751741002/ford-explorer-exterior_uohkrg.png",
    short: "Versatile and rugged SUV, ideal for family and adventure trips.",
    description:
      "The Ford Explorer is well-known for its roomy interior, robust safety features, and smooth drive. Features include climate control, MP3 support, and plenty of luggage space.",
    highlights: [
      "CD Stereo", "MP3 Connection", "Climate Control", "Large Cargo"
    ],
    seats: "7 seats",
    color: "Blue",
    price: 110,
    tag: "family"
  }
];

export const CarRentalProvider = ({ children }) => {
  const [carRentals, setCarRentals] = useState(initialCars);
  const [selectedCar, setSelectedCar] = useState(null);
  const [favorites, setFavorites] = useState(getInitialFavorites);

  const getCarBySlug = (slug) =>
    carRentals.find((car) =>
      car.name.toLowerCase().replace(/,/g, "").replace(/\s+/g, "-") === slug
    );

  const toggleFavorite = (car) => {
    const exists = favorites.some((c) => c.id === car.id);
    const updated = exists
      ? favorites.filter((c) => c.id !== car.id)
      : [...favorites, car];

    setFavorites(updated);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updated));
  };

  const isFavorite = (carId) => favorites.some((c) => c.id === carId);

  return (
    <CarRentalContext.Provider
      value={{
        carRentals,
        selectedCar,
        setSelectedCar,
        getCarBySlug,
        favorites,
        toggleFavorite,
        isFavorite,
      }}
    >
      {children}
    </CarRentalContext.Provider>
  );
};

export const useCarRentalContext = () => useContext(CarRentalContext);
